import require from '@/utils/request'
import {
  WebhookPageForm,
  WebhookEditForm,
  WebhookUpdataForm,
  WebhookTaskPageForm } from '@/types/Webhook'
/**
 *
 * @param data
 * WebhookAddStepPage 计划看板添加 步骤三
 * name 选择webhook下拉框 内容
 * params webhook参数
 *    "type": "custom" 时 为自定义参数
 *     其他状态均为预设参数
 *      状态
 *      instanceId 无value 空白即可 创建时也不填
 *      preinstall 必填 有value
 *      custom     自定义
 *
 *
 * WebhookPage 系统配置 webhook管理 分页
 *
 * WebhookDetail 获取系统配置页面 表格编辑获取单条数据
 *
 * WebhookAdd     获取系统配置页面 新增webhook
 *
 * WebhookUpdata     获取系统配置页面 修改更新webhook
 */
export const WebhookAddStepPage = (data:{}) => require({
  url: '/webhook/queryByPage',
  method: 'post',
  data
})

export const WebhookPage = (data:WebhookPageForm) => require({
  url: '/webhook/queryByPage',
  method: 'post',
  data
})

export const WebhookDetail = (id:number) => require({
  url: '/webhook/detail/' + id,
  method: 'get'
})

export const WebhookAdd = (data:WebhookEditForm) => require({
  url: '/webhook/add',
  method: 'post',
  data
})

export const WebhookUpdata = (data:WebhookUpdataForm) => require({
  url: '/webhook/update',
  method: 'post',
  data
})

export const WebhookTaskPage = (data: WebhookTaskPageForm) => require({
  url: '/planExecuteWebhook/queryPage',
  method: 'post',
  data
})
export const WebhookDel = (id:number) => require({
  url: '/planExecuteWebhook/delete/' + id,
  method: 'post'
})
